// services/ConsentService.ts
import { HttpStatusCode } from 'constantsValues';
import { ConsentUpdateRequest, CustomerConsent } from 'generated-api/bff/api';
import { getApiInstance } from './Api';

const BASE_PATH = '/commercial-selfservice/';

class ConsentService {
	async fetch(): Promise<CustomerConsent[]> {
		const apiInstance = await getApiInstance(BASE_PATH);
		const response = await apiInstance.bffApiServiceLayer.getCustomerDetails();

		if (response.status === HttpStatusCode.NoContent) {
			return [];
		}

		if (!response.data?.consents) {
			throw new Error('No consents found');
		}

		return response.data.consents;
	}

	async update(consentUpdateRequest: ConsentUpdateRequest[]): Promise<CustomerConsent[]> {
		const apiInstance = await getApiInstance(BASE_PATH);
		const response = await apiInstance.bffApiServiceLayer.updateCustomerConsents(consentUpdateRequest);

		if (!response.data?.consents) {
			throw new Error('Failed to update consents');
		}

		return response.data.consents;
	}
}

export const consentService = new ConsentService();
